<template>
  <div>
    <h2 class="text-h6">Subject</h2>
    <h3 class="h4 subtitle mb-4 text-muted">
      Set a subject that will appear on all outgoing email for this client. This will override any global subject text
      set up for your client.
    </h3>
    <c-row class="my-3">
      <c-col sm="1">
        <label class="label my-1" for="enabled">
          <span><strong>Enabled</strong></span>
        </label>
      </c-col>
      <c-col>
        <c-switch
          id="enabled"
          class="float-left"
          color="success"
          :checked="enabled"
          shape="pill"
          @update:checked="toggleEnabled"
        />
      </c-col>
    </c-row>
    <c-input
      v-model="subjectText"
      class="input"
      type="text"
      placeholder="Your client subject text"
      @keydown="allowSave"
    />
    <c-button-group>
      <c-button color="primary" :disabled="!enableSave" :class="{ 'is-loading': isSaving }" @click="save">
        Save subject
      </c-button>
      <c-button v-if="showCancelButton" color="secondary" @click="cancelEdit">Cancel</c-button>
    </c-button-group>
  </div>
</template>

<script>
import _ from 'lodash';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  components: {
    Notification,
  },
  props: {
    client: Object,
  },
  data() {
    return {
      error: null,
      isSaving: false,
      success: false,
      showCancelButton: false,
      enableSave: false,
      subjectText: null,
      enabled: null,
      requiredFields: {
        subjectText: false,
      },
    };
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.subjectText = _.get(this.client, 'config.email.subjectText', '');
      this.enabled = _.get(this.client, 'config.email.subjectEnabled', false);
    },
    cancelEdit() {
      this.setData();
      this.resetButtonState();
    },
    resetButtonState() {
      this.showCancelButton = false;
      this.enableSave = false;
    },
    toggleEnabled(enabled) {
      this.enabled = enabled;
      this.allowSave();
    },
    allowSave() {
      this.showCancelButton = true;
      this.enableSave = true;
    },
    save() {
      this.isSaving = true;
      this.error = null;
      const data = {
        id: this.client._id,
        subjectText: this.subjectText,
        subjectEnabled: this.enabled,
      };
      this.$http
        .post(buildEndpoint('clients/email/update-subject-text'), data)
        .then((response) => {
          this.isSaving = false;
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Subject saved',
            });
            _.set(this.client, 'config.email.subjectText', this.subjectText);
            this.resetButtonState();
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: 'Error saving email content',
            });
          }
        })
        .catch((error) => {
          this.isSaving = false;
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped=""></style>
